import type React from 'react';
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@shadeables/ui';
import LoggedInContentWrapper from '../../components/LoggedInContentWrapper';
import styles from './Settings.module.css';
import SettingsUser from './SettingsUser';
import SettingsBilling from './SettingsBilling';

const Settings: React.FC = () => {
  const { tab } = useParams<{ tab?: string }>();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('user');

  useEffect(() => {
    if (tab === 'billing') {
      setActiveTab('billing');
    } else if (tab === 'user') {
      setActiveTab('user');
    } else if (tab) {
      // If invalid tab, redirect to user
      navigate('/settings/user', { replace: true });
    }
  }, [tab, navigate]);

  const handleTabChange = (newTab: string) => {
    setActiveTab(newTab);
    navigate(`/settings/${newTab}`, { replace: true });
  };

  return (
    <LoggedInContentWrapper title="Settings">
      <div className={styles.tabs}>
        <Button
          variant={activeTab === 'user' ? 'primary' : 'ghost'}
          onClick={() => handleTabChange('user')}
        >
          User
        </Button>
        <Button
          variant={activeTab === 'billing' ? 'primary' : 'ghost'}
          onClick={() => handleTabChange('billing')}
        >
          Billing
        </Button>
      </div>
      <div className={styles.tabContent}>
        {activeTab === 'user' && <SettingsUser />}
        {activeTab === 'billing' && <SettingsBilling />}
      </div>
    </LoggedInContentWrapper>
  );
};

export default Settings;
